import { logger } from '@/utils/logger/logger';

/**
 * Copilot telemetry funnel to Datadog. Fields must stay PHI-safe: outcome
 * tokens, error codes, counts, and durations only — never note content,
 * patient names, or field values (those stay in the on-device action log).
 */
const copilotLogger = logger.child({ module: 'copilot' });

export type CopilotTelemetryFields = Record<
  string,
  string | number | boolean | undefined
>;

/**
 * Compile-time guard: accepts any string literal but rejects a value typed as
 * plain `string`, so a dynamic (potentially PHI-carrying) value cannot become
 * an event label.
 */
export type StaticEventLabel<E extends string> = string extends E ? never : E;

export const logCopilotTelemetry = <E extends string>(
  event: StaticEventLabel<E>,
  fields: CopilotTelemetryFields = {}
): void => {
  const bound = Object.fromEntries(
    Object.entries(fields).filter(([, value]) => value !== undefined)
  );
  copilotLogger.child(bound).info(event);
};
